/**
 * @generated SignedSource<<d1d0f6ad7a8bbb1684606236947f2d46>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateBeliefSystemCriteriaInput = {
  beliefSystemIds?: ReadonlyArray<any | null | undefined> | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type useBeliefSystemCriteriaMutation$variables = {
  input: UpdateBeliefSystemCriteriaInput;
};
export type useBeliefSystemCriteriaMutation$data = {
  readonly updateBeliefSystemCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useBeliefSystemCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useBeliefSystemCriteriaMutation = {
  response: useBeliefSystemCriteriaMutation$data;
  variables: useBeliefSystemCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBeliefSystemCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateBeliefSystemCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateBeliefSystemCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useBeliefSystemCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useBeliefSystemCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateBeliefSystemCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateBeliefSystemCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "BeliefSystemCriterionConnection",
                    "kind": "LinkedField",
                    "name": "beliefSystemCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BeliefSystemCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "beliefSystemId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "beliefSystemCriteria(orderBy:[\"BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1bccb67c35322834b46e27e6d489ee32",
    "id": null,
    "metadata": {},
    "name": "useBeliefSystemCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useBeliefSystemCriteriaMutation(\n  $input: UpdateBeliefSystemCriteriaInput!\n) {\n  updateBeliefSystemCriteria(input: $input) {\n    query {\n      ...useBeliefSystemCriteria_query\n      id\n    }\n  }\n}\n\nfragment useBeliefSystemCriteria_query on Query {\n  currentUser {\n    beliefSystemCriteria(orderBy: [BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC]) {\n      nodes {\n        beliefSystemId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9ec0e008f7897b20bf86de45f1f45b2c";

export default node;
